import angular from 'angular';
import 'angular-ui-bootstrap'

import CustomFeedbackTableRowComponent from './custom.feedback.tr/custom.feedback.tr.ts';


export default angular.module('FE2.components.units', ['ui.bootstrap'])
  .directive('customFeedbackRow', () => new CustomFeedbackTableRowComponent())
  .name;
